import React from 'react';
import {
    HTMLContainer,
    ShapeUtil,
    T,
    TLResizeInfo,
    Rectangle2d,
    Geometry2d,
    resizeBox,
  } from 'tldraw';
  import AnalysisCardShape from './AnalysisCardShape'; // Import your shape type
  
  // [1]
  export class AnalysisCardShapeUtil extends ShapeUtil<AnalysisCardShape> {
    // [a]
    static override type = 'analysis-card' as const;
  
    // [b]
    static override props = {
      w: T.number,
      h: T.number,
      text: T.string,
      color: T.string, // Add the color property to the ShapeUtil's props
    };
  
    // [c]
    getDefaultProps(): AnalysisCardShape['props'] {
      return {
        w: 200,
        h: 100,
        text: 'New Analysis Card',
        color: '#ADD8E6', // Light blue default color
      };
    }
  
    // [d]
    getGeometry(shape: AnalysisCardShape): Geometry2d {
      return new Rectangle2d({
        width: shape.props.w,
        height: shape.props.h,
        isFilled: true,
      });
    }
  
    // [e]
    component(shape: AnalysisCardShape) {
      const { w, h, text, color } = shape.props;
  
      return (
        <HTMLContainer
          id={shape.id}
          style={{
            width: w,
            height: h,
            backgroundColor: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #333',
            borderRadius: '4px',
            boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
          }}
        >
          <div style={{ padding: '8px', textAlign: 'center', color: '#333' }}>
            {text}
          </div>
        </HTMLContainer>
      );
    }
  
    // [f]
    indicator(shape: AnalysisCardShape) {
      const { w, h } = shape.props;
      return <rect width={w} height={h} />;
    }
  
    // [g]
    override onResize(shape: AnalysisCardShape, info: TLResizeInfo<AnalysisCardShape>) {
      return resizeBox(shape, info);
    }
  }